module.exports = __webpack_public_path__ + "img/QRbg.056ad00d.png";